/**
 *
 * Validação se o NIF introduzido é Português.
 *
 * @param {String} value
 * @return {Boolean}
 *
*/
const validateNIF = value => {
    if ( !value ) // se não existir valor
        return true;

    if ( value.length > 9 ) // se o valor for maior que 8 digitos.
        return false;

    // validação das combinações iniciais possíveis
    // no NIF PT. Caso o valor introduzido não entre nestas
    // combinações, quer dizer que não é um NIF PT.
    const firstDigit = [ '1', '2', '3', '5', '6', '8' ];
    const firstTwoDigits = [
        '45',
        '70',
        '71',
        '72',
        '74',
        '75',
        '77',
        '78',
        '79',
        '90',
        '91',
        '97',
        '98',
        '99'
    ];

    if (
        !firstDigit.includes( value.substr( 0, 1 ) )
        && !firstTwoDigits.includes( value.substr( 0, 2 ) )
    )
        return false;

    const total = value[0] * 9 + value[1] * 8 + value[2] * 7 + value[3] * 6 + value[4] * 5 + value[5] * 4 + value[6] * 3 + value[7] * 2;
    const modulo11 = total - parseInt( total / 11, 10 ) * 11;
    const lastNumber = ( modulo11 === 1 || modulo11 === 0 ) ? 0 : 11 - modulo11;

    return parseInt( value[8], 10 ) === lastNumber;
};

export default {
    validateNIF
};